// validators/password.ts
import { z } from 'zod';

export const allowedSpecialChars = '@$!%*?&#.';

export const passwordSchema = z
  .string()
  .min(8, { message: 'Password must be at least 8 characters long' })
  .regex(
    new RegExp(
      `^(?=.*[A-Za-z])(?=.*\\d)(?=.*[${allowedSpecialChars}])[A-Za-z\\d${allowedSpecialChars}]{8,}$`
    ),
    {
      message: `Password must contain at least one letter, one number, and one special character (${allowedSpecialChars
        .split('')
        .join(' ')})`,
    }
  );
